(() => {
  'use strict';
  const storageKey = 'aldo-marketplace-saved';
  let saved = new Set();
  try { saved = new Set(JSON.parse(localStorage.getItem(storageKey) || '[]')); } catch (_) { /* Storage is optional. */ }
  let savedView = location.hash === '#saved';
  let toastTimer;
  const closingTimers = new WeakMap();
  const dialogTriggers = new WeakMap();
  let stickyObserver;
  let browseScrollY = 0;
  let changingCart = false;
  let modalRouteActive = false;
  let photoRouteActive = false;
  const baseTitle = document.title;
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const filterValue = selector => $(`${selector}:checked`)?.value || $(`${selector}:not([type="radio"])`)?.value || '';
  const readResponse = async (response, message) => {
    try { return await response.json(); } catch (_) { throw new Error(message); }
  };
  const productDialog = $('#MarketProductDialog');
  const cartDialog = $('#MarketCartDialog');
  const imageDialog = $('#MarketImageDialog');
  const dismissMenus = except => $$('.mp-account-menu[open], .mp-post-menu[open]').forEach(menu => {
    if (!menu.contains(except)) menu.open = false;
  });
  const initializeProduct = product => {
    stickyObserver?.disconnect();
    if (!product) return;
    const bar = $('[data-sticky-purchase]', product);
    const button = $('[data-main-add]', product);
    if (!bar || !button) return;
    bar.hidden = true;
    if (!matchMedia('(max-width:767px) and (min-height:501px)').matches || !('IntersectionObserver' in window)) return;
    const root = product.closest('dialog, .mp-product-page');
    stickyObserver = new IntersectionObserver(([entry]) => {
      bar.hidden = entry.isIntersecting && entry.intersectionRatio >= .99;
    }, { root, threshold: [0, 1] });
    stickyObserver.observe(button);
  };
  const toast = (message) => {
    const element = $('.mp-toast');
    element.textContent = message;
    element.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { element.hidden = true; }, 2800);
  };
  const syncSaved = () => {
    $$('[data-save]').forEach(button => {
      const isSaved = saved.has(button.dataset.save);
      button.setAttribute('aria-pressed', String(isSaved));
      const label = $('span:not(.mp-icon)', button);
      if (label) label.textContent = isSaved ? 'Saved' : 'Save';
      if (button.classList.contains('mp-card-save')) {
        const card = button.closest('[data-listing]');
        button.setAttribute('aria-label', `${isSaved ? 'Unsave' : 'Save'} ${$('h3', card).textContent}`);
      }
    });
  };
  const filterListings = () => {
    const scope = $('[data-market-listings]');
    if (!scope) return;
    const term = ($('[data-market-search]')?.value || '').trim().toLowerCase();
    const cards = $$('[data-listing]', scope);
    const size = filterValue('[data-filter-size]');
    const availability = filterValue('[data-filter-availability]');
    let shown = 0;
    cards.forEach(card => {
      card.hidden = !card.dataset.title.includes(term) || (savedView && !saved.has(card.dataset.listing)) || (size && !card.dataset.sizes.split('|').includes(size)) || (availability && card.dataset.available !== 'true');
      if (!card.hidden) shown++;
    });
    const empty = $('[data-empty]', scope);
    if (empty) {
      empty.hidden = shown > 0;
      $('h3', empty).textContent = savedView && !term ? 'No saved listings' : 'No listings found';
    }
    const heading = $('[data-listing-heading]', scope);
    if (heading) {
      heading.dataset.original ||= heading.textContent;
      heading.textContent = savedView ? 'Saved' : term ? 'Search results' : heading.dataset.original;
    }
    $$('[data-browse], [data-saved-view]').forEach(link => {
      link.classList.toggle('is-active', link.hasAttribute('data-saved-view') ? savedView : !savedView && !link.closest('.mp-category'));
    });
    const marketplaceTab = $('.mp-header-tab[aria-label="Marketplace"]');
    marketplaceTab?.classList.toggle('is-active', !savedView);
    if (marketplaceTab) marketplaceTab.setAttribute('aria-current', savedView ? 'false' : 'page');
  };
  const animateListings = () => {
    const listings = $('[data-market-listings]');
    if (!listings || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    listings.classList.remove('is-changing');
    requestAnimationFrame(() => requestAnimationFrame(() => listings.classList.add('is-changing')));
  };
  const openDialog = (dialog, trigger) => {
    if (!dialog?.showModal) return false;
    clearTimeout(closingTimers.get(dialog));
    dialog.classList.remove('is-closing');
    dismissMenus();
    dialogTriggers.set(dialog, trigger);
    if (!dialog.open) dialog.showModal();
    dialog.scrollTop = 0;
    if (dialog === productDialog) initializeProduct($('.mp-product', dialog));
    return true;
  };
  const closeDialog = (dialog, restoreRoute = true) => {
    if (!dialog?.open) return;
    if (dialog === productDialog && modalRouteActive && restoreRoute) { history.back(); return; }
    if (dialog === imageDialog && photoRouteActive && restoreRoute) { history.back(); return; }
    if (dialog.classList.contains('is-closing')) return;
    dialog.classList.add('is-closing');
    const trigger = dialogTriggers.get(dialog);
    const finish = () => {
      dialog.close();
      dialog.classList.remove('is-closing');
      if (dialog === productDialog) { stickyObserver?.disconnect(); window.scrollTo({ top:browseScrollY, behavior:'instant' }); }
      (trigger?.isConnected && !trigger.closest('dialog:not([open])') ? trigger : $('.mp-header [data-open-cart]'))?.focus({ preventScroll: true });
    };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
    else closingTimers.set(dialog, setTimeout(finish, 120));
  };
  const updateVariant = (form) => {
    const radio = $('input[name="id"]:checked', form);
    if (!radio) return;
    const product = form.closest('.mp-product');
    $$('[data-add-to-cart]', product).forEach(submit => {
      submit.disabled = radio.dataset.available !== 'true';
      submit.textContent = submit.disabled ? 'Sold out' : 'Add to cart';
    });
    $$('[data-variant-price]', product).forEach(price => { price.textContent = radio.dataset.price; });
    $('.mp-form-error', form).hidden = true;
    if (!form.closest('dialog') || modalRouteActive) {
      const url = new URL(location.href);
      url.searchParams.set('variant', radio.value);
      history.replaceState(history.state, '', url);
    }
  };
  const leaveProductRoute = () => {
    stickyObserver?.disconnect();
    if (productDialog.open) productDialog.close();
    if (modalRouteActive) { modalRouteActive = false; history.back(); }
    document.title = baseTitle;
  };
  const refreshCart = async () => {
    const response = await fetch(`${window.routes.cart_url}?section_id=market-cart`, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Could not load your cart. Please try again.');
    const html = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = $('[data-cart-content]', html);
    if (!content) throw new Error('Could not load your cart. Please try again.');
    $$('[data-cart-content]').forEach(existing => {
      const copy = content.cloneNode(true);
      const instance = existing.closest('dialog') ? 'drawer' : 'page';
      $$('[id]', copy).forEach(input => {
        const previous = input.id;
        input.id = previous.replace('Quantity-page-', `Quantity-${instance}-`);
        const label = $(`label[for="${previous}"]`, copy);
        if (label) label.htmlFor = input.id;
      });
      existing.replaceWith(copy);
    });
    const countResponse = await fetch(`${window.routes.cart_url}.js`, { credentials: 'same-origin' });
    if (countResponse.ok) {
      const cart = await countResponse.json();
      $$('[data-cart-count]').forEach(element => { element.textContent = cart.item_count; element.hidden = !cart.item_count; });
    }
  };
  const changeCart = async (key, quantity, source) => {
    if (changingCart) return;
    changingCart = true;
    const form = source.closest('.mp-cart-form');
    form?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(`${window.routes.cart_change_url}.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      const result = await readResponse(response, 'Could not update your cart. Please try again.');
      if (!response.ok) throw new Error(result.description || result.message || 'Could not update your cart.');
      await refreshCart();
    } catch (error) {
      const message = $('.mp-form-error', form);
      if (message) { message.textContent = error.message; message.hidden = false; }
      else toast(error.message);
    } finally {
      changingCart = false;
      form?.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click', async event => {
    dismissMenus(event.target);
    const target = event.target.closest('a, button');
    if (!target) return;
    if (target.matches('[data-open-product]') && !event.ctrlKey && !event.metaKey && !event.shiftKey) {
      const template = document.getElementById(`MarketTemplate-${target.dataset.openProduct}`);
      if (!template || !productDialog?.showModal) return;
      event.preventDefault();
      browseScrollY = window.scrollY;
      $('[data-product-dialog-content]').replaceChildren(template.content.cloneNode(true));
      syncSaved();
      openDialog(productDialog, target);
      const url = new URL(target.href);
      const previewId = new URL(location.href).searchParams.get('preview_theme_id');
      if (previewId) url.searchParams.set('preview_theme_id', previewId);
      history.pushState({ marketProduct: true, productId: target.dataset.openProduct }, '', url);
      modalRouteActive = true;
      document.title = `${$('h1', productDialog).textContent} | ${baseTitle}`;
      const preferredSize = filterValue('[data-filter-size]');
      const preferredVariant = $$('input[name="id"]', productDialog).find(input => input.getAttribute('aria-label')?.split(',')[0] === preferredSize);
      if (preferredVariant) { preferredVariant.checked = true; updateVariant(preferredVariant.form); }
      return;
    }
    if (target.matches('[data-open-photo]')) {
      const source = $('img', target);
      const image = $('img', imageDialog);
      image.src = source.src;
      image.alt = source.alt;
      $('.mp-image-scroll', imageDialog).classList.remove('is-zoomed');
      $('[data-zoom-photo]', imageDialog).setAttribute('aria-pressed', 'false');
      $('[data-zoom-photo]', imageDialog).setAttribute('aria-label', 'Zoom in');
      openDialog(imageDialog, target);
      history.pushState({ ...history.state, marketPhoto:true, photoSrc:source.src, photoAlt:source.alt }, '', location.href);
      photoRouteActive = true;
      return;
    }
    if (target.matches('[data-zoom-photo]')) {
      const zoomed = $('.mp-image-scroll', imageDialog).classList.toggle('is-zoomed');
      target.setAttribute('aria-pressed', String(zoomed));
      target.setAttribute('aria-label', zoomed ? 'Zoom out' : 'Zoom in');
      return;
    }
    if (target.matches('[data-save]')) {
      event.preventDefault();
      const handle = target.dataset.save;
      if (saved.has(handle)) saved.delete(handle); else saved.add(handle);
      try { localStorage.setItem(storageKey, JSON.stringify([...saved])); } catch (_) { /* Keep saved items for this visit. */ }
      syncSaved(); filterListings();
      return;
    }
    if (target.matches('[data-saved-view], [data-browse], [data-reset-listings]') && $('[data-market-listings]')) {
      event.preventDefault(); savedView = target.hasAttribute('data-saved-view');
      if (!savedView) {
        $('[data-market-search]').value = '';
        $$('[data-filter-size], [data-filter-availability]').forEach(input => {
          if (input.type === 'radio') input.checked = input.defaultChecked;
          else input.value = '';
        });
      }
      const url = new URL(location.href); url.hash = savedView ? 'saved' : '';
      history.replaceState(history.state, '', url);
      filterListings(); animateListings(); return;
    }
    if (target.matches('[data-open-cart]') && !event.ctrlKey && !event.metaKey && !event.shiftKey && cartDialog?.showModal) {
      event.preventDefault();
      leaveProductRoute();
      openDialog(cartDialog, target);
      try { await refreshCart(); } catch (error) { toast(error.message); }
      return;
    }
    if (target.matches('[data-close-dialog]')) { closeDialog(target.closest('dialog')); return; }
    if (target.matches('[data-toggle-filters]')) {
      const filters = $('#MarketFilters');
      if (matchMedia('(max-width:1023px)').matches) {
        filters.hidden = false;
        filters.classList.toggle('is-mobile-open');
        target.setAttribute('aria-expanded', String(filters.classList.contains('is-mobile-open')));
      } else {
        filters.hidden = !filters.hidden;
        target.setAttribute('aria-expanded', String(!filters.hidden));
      }
      return;
    }
    if (target.matches('[data-remove]')) { event.preventDefault(); await changeCart(target.dataset.remove, 0, target); return; }
    if (target.matches('[data-gallery-image]')) {
      const gallery = target.closest('.mp-gallery');
      const image = $('.mp-product-image', gallery);
      image.removeAttribute('srcset'); image.src = target.dataset.galleryImage;
      const backdrop = $('.mp-gallery-backdrop', gallery);
      if (backdrop) { backdrop.removeAttribute('srcset'); backdrop.src = target.dataset.galleryImage; }
      $$('.mp-thumbnail', gallery).forEach(button => button.classList.toggle('is-active', button === target));
      return;
    }
    if (target.matches('[data-share]')) {
      const url = new URL(target.dataset.share, location.origin).href;
      try {
        if (navigator.share) await navigator.share({ title: $('h1', target.closest('.mp-product')).textContent, url });
        else { await navigator.clipboard.writeText(url); toast('Link copied'); }
      } catch (error) { if (error.name !== 'AbortError') toast('Could not share. Copy the product link from your browser.'); }
    }
  });
  document.addEventListener('input', event => {
    if (event.target.matches('[data-market-search]')) filterListings();
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('.mp-product-form input[name="id"]')) updateVariant(input.form);
    if (input.matches('[data-filter-size], [data-filter-availability]')) filterListings();
    if (input.matches('[data-cart-key]') && Number.isInteger(Number(input.value)) && Number(input.value) >= 0) changeCart(input.dataset.cartKey, Number(input.value), input);
    if (input.matches('[data-sort]')) {
      const grid = $('.mp-listing-grid');
      const cards = $$('[data-listing]', grid);
      cards.forEach((card, index) => { card.dataset.order ||= String(index); });
      cards.sort((a,b) => input.value === 'featured' ? Number(a.dataset.order) - Number(b.dataset.order) : (Number(a.dataset.price) - Number(b.dataset.price)) * (input.value === 'price-desc' ? -1 : 1));
      cards.forEach(card => grid.append(card));
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('.mp-search') && $('[data-market-listings]')) { event.preventDefault(); filterListings(); return; }
    if (!form.matches('.mp-product-form')) return;
    event.preventDefault();
    if (form.getAttribute('aria-busy') === 'true') return;
    const button = $('[data-add-to-cart]', form);
    if (button.disabled) return;
    const buttons = $$('[data-add-to-cart]', form.closest('.mp-product'));
    buttons.forEach(submit => { submit.disabled = true; submit.textContent = 'Adding…'; });
    form.setAttribute('aria-busy', 'true');
    const message = $('.mp-form-error', form); message.hidden = true;
    let added = false;
    try {
      const response = await fetch(`${window.routes.cart_add_url}.js`, { method:'POST', credentials:'same-origin', headers:{Accept:'application/json'}, body:new FormData(form) });
      const result = await readResponse(response, 'Could not add this shirt. Please try again.');
      if (!response.ok) throw new Error(result.description || result.message || 'Could not add this shirt. Please try again.');
      added = true;
      await refreshCart();
      leaveProductRoute();
      openDialog(cartDialog, button);
    } catch (error) {
      if (added) { toast('Added to cart'); location.href = window.routes.cart_url; }
      else { message.textContent = error.message; message.hidden = false; }
    } finally {
      form.removeAttribute('aria-busy');
      if ($('input[name="id"]:checked', form)) updateVariant(form);
      else buttons.forEach(submit => { submit.disabled = false; submit.textContent = 'Add to cart'; });
    }
  });
  [productDialog, cartDialog, imageDialog].forEach(dialog => {
    dialog?.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
    });
    dialog?.addEventListener('cancel', event => { event.preventDefault(); closeDialog(dialog); });
  });
  window.addEventListener('hashchange', () => { savedView = location.hash === '#saved'; filterListings(); });
  window.addEventListener('popstate', event => {
    if (event.state?.marketPhoto) {
      const image = $('img', imageDialog);
      image.src = event.state.photoSrc;
      image.alt = event.state.photoAlt;
      $('.mp-image-scroll', imageDialog).classList.remove('is-zoomed');
      $('[data-zoom-photo]', imageDialog).setAttribute('aria-pressed', 'false');
      $('[data-zoom-photo]', imageDialog).setAttribute('aria-label', 'Zoom in');
      openDialog(imageDialog, $('.mp-photo-open', productDialog.open ? productDialog : document));
      photoRouteActive = true;
      return;
    }
    if (photoRouteActive) {
      photoRouteActive = false;
      closeDialog(imageDialog, false);
      if (event.state?.marketProduct && modalRouteActive || !modalRouteActive) return;
    }
    if (event.state?.marketProduct) {
      const template = document.getElementById(`MarketTemplate-${event.state.productId}`);
      if (!template) return;
      $('[data-product-dialog-content]').replaceChildren(template.content.cloneNode(true));
      syncSaved();
      clearTimeout(closingTimers.get(productDialog));
      productDialog.classList.remove('is-closing');
      if (!productDialog.open) openDialog(productDialog, $(`.mp-card-image[data-open-product="${event.state.productId}"]`));
      else initializeProduct($('.mp-product', productDialog));
      modalRouteActive = true;
      document.title = `${$('h1', productDialog).textContent} | ${baseTitle}`;
      const variantId = new URL(location.href).searchParams.get('variant');
      const variant = $$('input[name="id"]', productDialog).find(input => input.value === variantId);
      if (variant) { variant.checked = true; updateVariant(variant.form); }
      return;
    }
    savedView = location.hash === '#saved';
    filterListings();
    if (!modalRouteActive) return;
    modalRouteActive = false;
    document.title = baseTitle;
    closeDialog(productDialog, false);
  });
  document.addEventListener('shopify:section:load', () => { syncSaved(); filterListings(); });
  const syncFilterToggle = () => {
    const filters = $('#MarketFilters');
    const button = $('[data-toggle-filters]');
    if (filters && matchMedia('(max-width:1023px)').matches) filters.hidden = false;
    if (filters && button) button.setAttribute('aria-expanded', String(matchMedia('(max-width:1023px)').matches ? filters.classList.contains('is-mobile-open') : !filters.hidden));
  };
  matchMedia('(max-width:1023px)').addEventListener('change', syncFilterToggle);
  matchMedia('(max-width:767px) and (min-height:501px)').addEventListener('change', () => initializeProduct($('.mp-product', productDialog.open ? productDialog : document)));
  document.addEventListener('keydown', event => { if (event.key === 'Escape') dismissMenus(); });
  initializeProduct($('.mp-product-page .mp-product'));
  syncSaved(); filterListings(); syncFilterToggle();
})();
